import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { setChecklinkHeaderMenuData } from "../../actions/headerMenu/headerMenu";
import footerCompanyLogo1 from "../../assets/images/AGS.png";
import AdminToolsDataService from "../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";
import { useTranslation } from "react-i18next";
import { Button, Modal, Select, Tooltip } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import logoImg from "../../assets/images/logo-img.png";
import "../../assets/css/login-cinematic.css";

import necklaceImg from "../../assets/images/model_necklace.png";
import diamondRingImg from "../../assets/images/model_diamond_ring.png";
import earringImg from "../../assets/images/model_earring.png";
import lightThemeBg from "../../assets/images/light_theme_bg.png";

const Register = (props) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [phoneCountry, setPhoneCountry] = useState("us");

  const [isLightMode, setIsLightMode] = useState(() => {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return false;
    }
    return true;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => setIsLightMode(!e.matches);
    
    // Fallback for older browsers
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleChange);
      return () => mediaQuery.removeListener(handleChange);
    }
  }, []);

  const [currentStep, setCurrentStep] = useState(0);

  const validateStep = async (step) => {
    const validationsCopy = { ...validations };
    let isValid = true;

    if (step === 0) {
      if (!RegisterData.companyName.trim()) {
        validationsCopy.companyNameVal = "Company name is compulsory";
        isValid = false;
      } else {
        // If there is a previous server check message "Company Name is Taken", preserve it
        if (validationsCopy.companyNameVal === "Company Name is Taken") {
          isValid = false;
        } else {
          validationsCopy.companyNameVal = "";
        }

        // Always verify uniqueness before moving next
        const isCompanyExist = await handleCheckDealerCompanyName();
        if (isCompanyExist) {
          validationsCopy.companyNameVal = "Company Name is Taken";
          isValid = false;
        }
      }
      if (!RegisterData.address.trim()) {
        validationsCopy.addressVal = "Address is compulsory";
        isValid = false;
      } else {
        validationsCopy.addressVal = "";
      }
      if (!RegisterData.country) {
        validationsCopy.countryVal = "Kindly select the Country";
        isValid = false;
      } else {
        validationsCopy.countryVal = "";
      }
      if (!RegisterData.state) {
        validationsCopy.stateVal = "State is compulsory";
        isValid = false;
      } else {
        validationsCopy.stateVal = "";
      }
      if (!RegisterData.city) {
        validationsCopy.cityVal = "City is compulsory";
        isValid = false;
      } else {
        validationsCopy.cityVal = "";
      }
      if (!RegisterData.zipCode.trim()) {
        validationsCopy.zipCodeVal = "Zip Code is compulsory";
        isValid = false;
      } else {
        validationsCopy.zipCodeVal = "";
      }
      if (!RegisterData.accountType) {
        validationsCopy.accountTypeVal = "Kindly select the Account Type";
        isValid = false;
      } else {
        validationsCopy.accountTypeVal = "";
      }
    } else if (step === 1) {
      if (!RegisterData.firstName.trim()) {
        validationsCopy.firstNameVal = "First name is compulsory";
        isValid = false;
      } else {
        validationsCopy.firstNameVal = "";
      }
      if (!RegisterData.lastName.trim()) {
        validationsCopy.lastNameVal = "Last name is compulsory";
        isValid = false;
      } else {
        validationsCopy.lastNameVal = "";
      }
      if (!RegisterData.email.trim()) {
        validationsCopy.emailVal = "Email address is compulsory";
        isValid = false;
      } else {
        validationsCopy.emailVal = "";
      }
      if (!RegisterData.contactNo.trim()) {
        validationsCopy.contactNoVal = "Phone number is compulsory";
        isValid = false;
      } else if (
        (RegisterData.contactNo.length >= 10 && RegisterData.contactNo.includes("-")) ||
        (RegisterData.contactNo.length >= 10 && RegisterData.contactNo.includes(",")) ||
        (RegisterData.contactNo.length >= 10 && RegisterData.contactNo.includes("+")) ||
        /^(?!0{10,15})(\+\d{1,3}[-]?)?\d{10,15}$/.test(RegisterData.contactNo)
      ) {
        validationsCopy.contactNoVal = "";
      } else {
        validationsCopy.contactNoVal = "Phone number is invalid";
        isValid = false;
      }
    } else if (step === 2) {
      if (!RegisterData.userName.trim()) {
        validationsCopy.userNameVal = "User name is compulsory";
        isValid = false;
      } else {
        validationsCopy.userNameVal = "";
      }
      const strongRegex = new RegExp(
        "^(?=.*[a-z])(?!.* )(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,15})"
      );
      if (!RegisterData.password.trim()) {
        validationsCopy.passwordVal = "Password is compulsory";
        isValid = false;
      } else if (!RegisterData.password.match(strongRegex)) {
        validationsCopy.passwordVal =
          "Password must contain minimum 8 characters, at least one uppercase letter, one lowercase letter, one number and one special character";
        isValid = false;
      } else {
        validationsCopy.passwordVal = "";
      }
    }

    setValidations(validationsCopy);
    return isValid;
  };

  const handleNext = async () => {
    const isStepValid = await validateStep(currentStep);
    if (isStepValid) {
      setCurrentStep((prev) => prev + 1);
    }
  };
  const handleBack = () => setCurrentStep((prev) => prev - 1);

  const { Option } = Select;
  // ... rest of state and effects ...
  const [RegisterData, setRegisterData] = useState({
    companyName: "",
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "",
    zipCode: "",
    userName: "",
    password: "",
    accountType: "",
    contactNo: "",
    partnerCode: "",
  });
  // Non-blocking live-validation status for the optional partner code.
  const [partnerCodeStatus, setPartnerCodeStatus] = useState({
    state: "", // "" | "valid" | "invalid"
    message: "",
  });
  const [validations, setValidations] = useState({
    companyNameVal: "",
    firstNameVal: "",
    lastNameVal: "",
    emailVal: "",
    addressVal: "",
    cityVal: "",
    stateVal: "",
    countryVal: "",
    zipCodeVal: "",
    userNameVal: "",
    passwordVal: "",
    accountTypeVal: "",
    contactNoVal: "",
  });

  const [submitLoading, setSubmitLoading] = useState(false);
  const [showPassword, setshowPassword] = useState(false);

  const handlePartnerCodeChange = (e) => {
    setRegisterData({
      ...RegisterData,
      partnerCode: e.target.value,
    });
    setPartnerCodeStatus({ state: "", message: "" });
  };

  // Optional, non-blocking: validate the partner code on blur and show ✓/✗.
  const handleValidatePartnerCode = () => {
    const code = (RegisterData.partnerCode || "").trim();
    if (!code) {
      setPartnerCodeStatus({ state: "", message: "" });
      return;
    }
    AdminToolsDataService.ValidatePartnerCodePublic({ code })
      .then((response) => {
        const result = response.data.responseData || response.data || {};
        if (response.data.message === "Success" && result.valid) {
          setPartnerCodeStatus({
            state: "valid",
            message: `✓ ${result.partnerName || ""}`.trim(),
          });
        } else {
          setPartnerCodeStatus({
            state: "invalid",
            message: t("Invalid code"),
          });
        }
      })
      .catch(() => {
        setPartnerCodeStatus({
          state: "invalid",
          message: t("Invalid code"),
        });
      });
  };

  const [locationDropdownListByCountry, setLocationDropdownListByCountry] =
    useState([]);
  const [locationDropdownListByState, setLocationDropdownListByState] =
    useState([]);
  const [locationDropdownListByCity, setLocationDropdownListByCity] = useState(
    []
  );

  const WhiteLabeling = useSelector((state) => state.loginReducer);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleLogoRedirection = () => {
    dispatch(setChecklinkHeaderMenuData("Dashboard"));
    navigate("/dashboard");
  };
  const search = useLocation().search;
  const paramCompanyName = new URLSearchParams(search).get("CompanyName");
  const paramCity = new URLSearchParams(search).get("City");
  const paramState = new URLSearchParams(search).get("State");
  const paramCountry = new URLSearchParams(search).get("Country");
  const paramContactName = new URLSearchParams(search).get("ContactName");
  const paramEmail = new URLSearchParams(search).get("Email");
  const paramPhoneNumber = new URLSearchParams(search).get("PhoneNumber");
  const paramType = new URLSearchParams(search).get("Type");

  useEffect(() => {
    if (paramCompanyName) {
      handleGetLocationDropdownDetailsByCountry();
      handleGetLocationDropdownDetailsByState(paramCountry, "State");
      handleGetLocationDropdownDetailsByCity(paramState, "City");
      setTimeout(() => {
        setRegisterData((prevState) => ({
          ...prevState,
          companyName: paramCompanyName ? paramCompanyName : "",
          city: paramCity ? parseInt(paramCity) : "",
          state: paramState ? parseInt(paramState) : "",
          country: paramCountry ? parseInt(paramCountry) : "",
          userName: paramContactName ? paramContactName : "",
          email: paramEmail ? paramEmail : "",
          contactNo: paramPhoneNumber ? paramPhoneNumber : "",
          accountType:
            paramType == "Retailer" ? "2" : paramType == "Vendor" ? "1" : "1",
        }));
      }, 2000);
    } else {
      handleGetLocationDropdownDetailsByCountry();
      handleGetLocationDropdownDetailsByState(233, "State");
    }
  }, []);

  useEffect(() => {
    const formContainer = document.querySelector('.login-cinematic-form-side');
    if (formContainer) formContainer.scrollTop = 0;
  }, [currentStep]);

  const handlePhoneChange = (value, data) => {
    // Remove country dial code
    if (data?.dialCode) {
      const dialCodeLength = data.dialCode.length;
      const withoutCode = value.replace(`+${data.dialCode}`, "");
      setRegisterData({
        ...RegisterData,
        ["contactNo"]: withoutCode,
      });
      setValidations((prevdata) => ({
        ...prevdata,
        contactNoVal: "",
      }));
    } else {
      setRegisterData({
        ...RegisterData,
        ["contactNo"]: value,
      });
      setValidations((prevdata) => ({
        ...prevdata,
        contactNoVal: "",
      }));
    }
  };

  const handleOnChange = (e, isSelect, name) => {
    if (isSelect === "select") {
      setRegisterData({
        ...RegisterData,
        [name]: e,
      });
      if (name === "country") {
        setValidations((prevdata) => ({
          ...prevdata,
          countryVal: "",
        }));
        handleGetLocationDropdownDetailsByState(e, "State");
      }
      if (name === "state") {
        setValidations((prevdata) => ({
          ...prevdata,
          stateVal: "",
        }));
        handleGetLocationDropdownDetailsByCity(e, "City");
      }
      if (name === "city") {
        setValidations((prevdata) => ({
          ...prevdata,
          cityVal: "",
        }));
      }
      if (name === "accountType") {
        setValidations((prevdata) => ({
          ...prevdata,
          accountTypeVal: "",
        }));
      }
    } else if (name === "contactNo") {
    } else {
      setRegisterData({
        ...RegisterData,
        [e.target.name]: e.target.value,
      });
      if (e.target.name === "companyName") {
        setValidations((prevdata) => ({
          ...prevdata,
          companyNameVal: "",
        }));
      }
      if (e.target.name === "firstName") {
        setValidations((prevdata) => ({
          ...prevdata,
          firstNameVal: "",
        }));
      }
      if (e.target.name === "lastName") {
        setValidations((prevdata) => ({
          ...prevdata,
          lastNameVal: "",
        }));
      }
      if (e.target.name === "email") {
        setValidations((prevdata) => ({
          ...prevdata,
          emailVal: "",
        }));
      }
      if (e.target.name === "address") {
        setValidations((prevdata) => ({
          ...prevdata,
          addressVal: "",
        }));
      }

      if (e.target.name === "zipCode") {
        setValidations((prevdata) => ({
          ...prevdata,
          zipCodeVal: "",
        }));
      }
      if (e.target.name === "userName") {
        setValidations((prevdata) => ({
          ...prevdata,
          userNameVal: "",
        }));
      }
      if (e.target.name === "password") {
        setValidations((prevdata) => ({
          ...prevdata,
          passwordVal: "",
        }));
      }
      if (e.target.name === "contactNo") {
        setValidations((prevdata) => ({
          ...prevdata,
          contactNoVal: "",
        }));
      }
    }
  };

  // Show Password

  const handlePassShowHide = () => {
    setshowPassword(!showPassword);
  };

  const handleValidation = () => {
    const validations = {};
    let isValid = true;

    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*/=?^_`{|}~]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    // For Password
    if (!RegisterData.companyName.trim()) {
      isValid = false;
      validations.companyNameVal = "Company name is compulsory";
    } else {
      validations.companyNameVal = "";
    }
    if (!RegisterData.firstName.trim()) {
      isValid = false;
      validations.firstNameVal = "First name is compulsory";
    } else {
      validations.firstNameVal = "";
    }
    if (!RegisterData.lastName.trim()) {
      isValid = false;
      validations.lastNameVal = "Last name is compulsory";
    } else {
      validations.lastNameVal = "";
    }
    var validEmailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!RegisterData.email.trim()) {
      isValid = false;
      validations.emailVal = "Email address is compulsory";
    } else if (!RegisterData.email.match(validEmailRegex)) {
      isValid = false;
      validations.emailVal = "Email address is invalid";
    } else {
      if (!RegisterData.email.match(validRegex)) {
        isValid = false;
        validations.emailVal = "Email address is invalid";
      } else {
        validations.emailVal = "";
      }
    }
    if (!RegisterData.address.trim()) {
      isValid = false;
      validations.addressVal = "Address is compulsory";
    } else {
      validations.addressVal = "";
    }
    if (!RegisterData.city) {
      isValid = false;
      validations.cityVal = "City is compulsory";
    } else {
      validations.cityVal = "";
    }
    if (!RegisterData.state) {
      isValid = false;
      validations.stateVal = "State is compulsory";
    } else {
      validations.stateVal = "";
    }
    if (!RegisterData.country) {
      isValid = false;
      validations.countryVal = "Kindly select the Country ";
    } else {
      validations.countryVal = "";
    }
    if (!RegisterData.zipCode.trim()) {
      isValid = false;
      validations.zipCodeVal = "Zip Code is compulsory";
    } else {
      validations.zipCodeVal = "";
    }
    if (!RegisterData.userName.trim()) {
      isValid = false;
      validations.userNameVal = "User name is compulsory";
    } else {
      validations.userNameVal = "";
    }
    const strongRegex = new RegExp(
      "^(?=.*[a-z])(?!.* )(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,15})"
    );
    if (!RegisterData.password.trim()) {
      isValid = false;
      validations.passwordVal = "Password is compulsory";
    } else if (!RegisterData.password.match(strongRegex)) {
      isValid = false;
      validations.passwordVal =
        "Password must contain minimum 8 characters, at least one uppercase letter, one lowercase letter, one number and one special character";
    } else {
      validations.passwordVal = "";
    }
    if (!RegisterData.accountType) {
      isValid = false;
      validations.accountTypeVal = "Kindly select the Account Type ";
    } else {
      validations.accountTypeVal = "";
    }

    if (!RegisterData.contactNo.trim()) {
      isValid = false;
      validations.contactNoVal = "Phone number is compulsory";
    } else if (
      (RegisterData.contactNo.length >= 10 &&
        RegisterData.contactNo.includes("-")) ||
      (RegisterData.contactNo.length >= 10 &&
        RegisterData.contactNo.includes(",")) ||
      (RegisterData.contactNo.length >= 10 &&
        RegisterData.contactNo.includes("+"))
    ) {
      validations.contactNoVal = "";
    } else if (
      !/^(?!0{10,15})(\+\d{1,3}[-]?)?\d{10,15}$/.test(RegisterData.contactNo)
    ) {
      isValid = false;
      validations.contactNoVal = "Phone number is invalid";
    } else {
      validations.contactNoVal = "";
    }
    if (!isValid) {
      setValidations(validations);
    }

    return isValid;
  };

  //Cascading Dropdown API starts
  const handleGetLocationDropdownDetailsByCountry = () => {
    let inputData = {
      id: 0,
      dropdownType: "Country",
    };

    AdminToolsDataService.GetLocationDropdownDetails(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (responseData) {
            setLocationDropdownListByCountry(responseData);
            setRegisterData((prevState) => ({
              ...prevState,
              country: 233,
            }));
          } else {
            setLocationDropdownListByCountry([]);
          }
        } else {
          setLocationDropdownListByCountry([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleGetLocationDropdownDetailsByState = (id, dropdownType) => {
    let inputData = {
      id: id,
      dropdownType: dropdownType,
    };
    AdminToolsDataService.GetLocationDropdownDetails(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setLocationDropdownListByState(responseData);
        } else {
          setLocationDropdownListByState([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleGetLocationDropdownDetailsByCity = (id, dropdownType) => {
    let inputData = {
      id: id,
      dropdownType: dropdownType,
    };
    AdminToolsDataService.GetLocationDropdownDetails(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setLocationDropdownListByCity(responseData);
        } else {
          setLocationDropdownListByCity([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // Cascading Dropdown API ends

  const handleCheckDealerCompanyName = async () => {
    try {
      if (!RegisterData.companyName) {
        return false;
      }
      let inputData = {
        companyName: RegisterData.companyName,
      };

      var isValid = true;
      await AdminToolsDataService.CheckDealerCompanyName(inputData)
        .then((response) => {
          var checkMessage = response.data.responseData.isCompanyExist;

          isValid = checkMessage;
          setValidations((prevState) => ({
            ...prevState,
            companyNameVal: checkMessage ? "Company Name is Taken" : "",
          }));
        })
        .catch((error) => {
          console.log(error);
        });
      return isValid; // Return isValid to use in validation flow
    } catch (error) {
      console.log(error);
    }
    return true; // Return true as fallback
  };

  const handleCheckDealerEmail = async () => {
    try {
      if (!RegisterData.email) {
        return false;
      }
      let inputData = {
        email: RegisterData.email,
      };

      var isValid = true;
      await AdminToolsDataService.CheckDealerEmail(inputData)
        .then((response) => {
          var checkMessage = response.data.responseData.isEmailExist;

          isValid = checkMessage;
          setValidations((prevState) => ({
            ...prevState,
            emailVal: checkMessage ? "Email is Taken" : "",
          }));
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleCheckDealerUser = async () => {
    try {
      if (!RegisterData.userName) {
        return false;
      }
      let inputData = {
        userName: RegisterData.userName,
      };
      var isValid = true;
      await AdminToolsDataService.CheckDealerUser(inputData)
        .then((response) => {
          var checkMessage = response.data.responseData.isUserNameExist;
          isValid = checkMessage;
          setValidations((prevState) => ({
            ...prevState,
            userNameVal: checkMessage && "Username is Taken",
          }));
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOpenLink = (link) => {
    window.open(link, "__blank");
  };

  const handleRegister = async () => {
    var isValid = handleValidation();
    if (!isValid) {
      return false;
    } else {
      setSubmitLoading(true);
      let promise1 = await handleCheckDealerEmail();
      let promise2 = await handleCheckDealerCompanyName();
      let promise3 = await handleCheckDealerUser();
      Promise.all([promise1, promise2, promise3]).then((values) => {
        let checker = (arr) => arr.every((v) => v === false);
        if (checker(values)) {
          setSubmitLoading(true);
          try {
            let inputData = {
              dealerId: 0,
              companyName: RegisterData.companyName,
              streetAddress: RegisterData.address,
              cityId: RegisterData.city || 0,
              stateId: RegisterData.state || 0,
              dealerCity: RegisterData.city
                ? (locationDropdownListByCity.find((item) => item.id === RegisterData.city)?.name || "")
                : "",
              dealerState: RegisterData.state
                ? (locationDropdownListByState.find((item) => item.id === RegisterData.state)?.name || "")
                : "",
              zipCode: RegisterData.zipCode,
              countryId: RegisterData.country,
              contactName: RegisterData.firstName + " " + RegisterData.lastName,
              emailAddress: RegisterData.email,
              phoneNumber: RegisterData.contactNo,
              userName: RegisterData.userName,
              password: RegisterData.password,
              permissionTypeId: RegisterData.accountType,
              partnerCode: RegisterData.partnerCode,
              isVerified: false,
              retailerStatusId: 0,
              vendorStatusId: 0,
              ipAddress: "noneknown",
              logInUser: 0,
              logInUserName: "datapending",
              isRegister: true,
              mailBody: "",
              mode: "mode",
            };
            setSubmitLoading(true);
            AdminToolsDataService.CreateNewClient(inputData)
              .then((response) => {
                var message = response.data.message;
                setSubmitLoading(false);
                if (message === "Success") {
                  NotificationManager.success(
                    t("User Registered Successfully.")
                  );

                  handleGetLocationDropdownDetailsByCountry();
                  handleGetLocationDropdownDetailsByState(233, "State");
                  setshowPassword(false);
                } else {
                  NotificationManager.success(t("User Registeration Failed."));
                }
              })
              .catch((error) => {
                console.log(error);
                setSubmitLoading(false);
              });
          } catch (error) {
            console.log(error);
            setSubmitLoading(false);
          }
          setVisible(true);
          setRegisterData({
            companyName: "",
            firstName: "",
            lastName: "",
            email: "",
            address: "",
            city: "",
            state: "",
            country: "",
            zipCode: "",
            userName: "",
            password: "",
            accountType: "",
            contactNo: "",
          });
          setValidations({
            companyNameVal: "",
            firstNameVal: "",
            lastNameVal: "",
            emailVal: "",
            addressVal: "",
            cityVal: "",
            stateVal: "",
            countryVal: "",
            zipCodeVal: "",
            userNameVal: "",
            passwordVal: "",
            accountTypeVal: "",
            contactNoVal: "",
          });
        } else {
          setSubmitLoading(false);
        }
      });
    }
  };
  const handleCancel = () => {
    setVisible(false);
  };

  const handleOnTop = () => {
    document.getElementsByClassName("content__area")[0].scroll(0, 0);
  };

  return (
    <div className={`login-cinematic-container ${isLightMode ? 'light-theme' : 'bg-slate-900'}`}>
      {/* Top Header overlay */}
      <div className="login-cinematic-top-header">
        <img
          src={logoImg}
          alt="Logo"
          className="top-header-logo"
          onClick={handleLogoRedirection}
        />
        <div className="d-none d-md-block" style={{ color: '#f8fafc', fontSize: '13px', letterSpacing: '2px', fontWeight: '500', textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
          SOCIAL PRODUCT NETWORK FOR THE JEWELRY INDUSTRY
        </div>
      </div>

      <div className="login-cinematic-split-screen">
        <div
          className="login-cinematic-image-side"
          style={{ backgroundImage: `url(${lightThemeBg})` }}
        ></div>

        <div className="login-cinematic-form-side" style={{ overflowY: "auto", position: 'relative', display: 'flex', flexDirection: 'column' }}>
          <div className="flex-grow-1 d-flex flex-column justify-content-center py-4 mt-5">
            <div className="login-cinematic-login-card mx-auto" style={{ maxWidth: '600px', width: '90%' }}>
              
              <h1 className="text-center mb-1">Registration</h1>
              <p className="text-center text-slate-400 mb-4">
                Stage {currentStep + 1} of 3: {currentStep === 0 ? "Business Details" : currentStep === 1 ? "Contact Details" : "Login Details"}
              </p>

              <div className="form__section_cinematic text-left">
                {currentStep === 0 && (
                  <div className="row animate-in">
                    <div className="col-12 mb-3">
                      <h3 className="text-slate-200 mb-2 border-bottom border-slate-700 pb-2">Business Details</h3>
                    </div>
                    <div className="col-lg-6">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">
                          Company Name <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Enter Company Name"
                          name="companyName"
                          value={RegisterData.companyName}
                          onChange={handleOnChange}
                          onBlur={handleCheckDealerCompanyName}
                          className={`login-input w-100 ${validations.companyNameVal ? "border-red-500" : ""}`}
                        />
                        {validations.companyNameVal && (
                          <p className="text-xs mt-1" style={{ color: 'red' }}>{validations.companyNameVal}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">Account Type <span className="text-red-500">*</span></label>
                        <Select
                          placeholder="Select Account Type"
                          value={RegisterData.accountType || null}
                          onChange={(e) => handleOnChange(e, "select", "accountType")}
                          className={`login-cinematic-select w-100 ${validations.accountTypeVal ? "border-red-500" : ""}`}
                        >
                          <Option>Select Account Type</Option>
                          <Option value="2">Retailer</Option>
                          <Option value="1">Jewelry Vendor</Option>
                          <Option value="3">Diamond Vendor</Option>
                        </Select>
                        {validations.accountTypeVal && <p className="text-xs mt-1" style={{ color: 'red' }}>{validations.accountTypeVal}</p>}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">Partner Code</label>
                        <input
                          type="text"
                          placeholder="Enter Partner Code (optional)"
                          name="partnerCode"
                          value={RegisterData.partnerCode}
                          onChange={handlePartnerCodeChange}
                          onBlur={handleValidatePartnerCode}
                          className="login-input w-100"
                        />
                        {partnerCodeStatus.message && (
                          <p
                            className="text-xs mt-1"
                            style={{ color: partnerCodeStatus.state === "valid" ? "green" : "red" }}
                          >
                            {partnerCodeStatus.message}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">Address <span className="text-red-500">*</span></label>
                        <input
                          type="text"
                          placeholder="Enter Address"
                          name="address"
                          value={RegisterData.address}
                          onChange={handleOnChange}
                          className={`login-input w-100 ${validations.addressVal && "border-red-500"}`}
                        />
                        {validations.addressVal && <p className="text-xs mt-1" style={{ color: 'red' }}>{validations.addressVal}</p>}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">Country <span className="text-red-500">*</span></label>
                        <Select
                          showSearch
                          placeholder="Select Country"
                          value={RegisterData.country || null}
                          onChange={(e) => handleOnChange(e, "select", "country")}
                          filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                          }
                          className={`login-cinematic-select w-100 ${validations.countryVal ? "border-red-500" : ""}`}
                        >
                          <Option>Select Country</Option>
                          {locationDropdownListByCountry.map((item) => (
                            <Option key={item.id} value={item.id}>{item.name}</Option>
                          ))}
                        </Select>
                        {validations.countryVal && <p className="text-xs mt-1" style={{ color: 'red' }}>{validations.countryVal}</p>}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">State <span className="text-red-500">*</span></label>
                        <Select
                          showSearch
                          placeholder="Select State"
                          value={RegisterData.state || null}
                          onChange={(e) => handleOnChange(e, "select", "state")}
                          filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                          }
                          className={`login-cinematic-select w-100 ${validations.stateVal ? "border-red-500" : ""}`}
                        >
                          <Option>Select State</Option>
                          {locationDropdownListByState.map((item) => (
                            <Option key={item.id} value={item.id}>{item.name}</Option>
                          ))}
                        </Select>
                        {validations.stateVal && <p className="text-xs mt-1" style={{ color: 'red' }}>{validations.stateVal}</p>}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">City <span className="text-red-500">*</span></label>
                        <Select
                          showSearch
                          placeholder="Select City"
                          value={RegisterData.city || null}
                          onChange={(e) => handleOnChange(e, "select", "city")}
                          filterOption={(input, option) =>
                            option.children.toLowerCase().includes(input.toLowerCase())
                          }
                          className={`login-cinematic-select w-100 ${validations.cityVal ? "border-red-500" : ""}`}
                        >
                          <Option>Select City</Option>
                          {locationDropdownListByCity.map((item) => (
                            <Option key={item.id} value={item.id}>{item.name}</Option>
                          ))}
                        </Select>
                        {validations.cityVal && <p className="text-xs mt-1" style={{ color: 'red' }}>{validations.cityVal}</p>}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">Zip Code <span className="text-red-500">*</span></label>
                        <input
                          type="text"
                          placeholder="Enter Zip Code"
                          name="zipCode"
                          value={RegisterData.zipCode}
                          onChange={handleOnChange}
                          className={`login-input w-100 ${validations.zipCodeVal && "border-red-500"}`}
                        />
                        {validations.zipCodeVal && <p className="text-xs mt-1" style={{ color: 'red' }}>{validations.zipCodeVal}</p>}
                      </div>
                    </div>
                  </div>
                )}

                {currentStep === 1 && (
                  <div className="row animate-in">
                    <div className="col-12 mb-3">
                      <h3 className="text-slate-200 mb-2 border-bottom border-slate-700 pb-2">Contact Details</h3>
                    </div>
                    <div className="col-lg-6">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">First Name <span className="text-red-500">*</span></label>
                        <input
                          type="text"
                          placeholder="Enter First Name"
                          name="firstName"
                          value={RegisterData.firstName}
                          onChange={handleOnChange}
                          className={`login-input w-100 ${validations.firstNameVal && "border-red-500"}`}
                        />
                        {validations.firstNameVal && <p className="text-xs mt-1" style={{ color: 'red' }}>{validations.firstNameVal}</p>}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">Last Name <span className="text-red-500">*</span></label>
                        <input
                          type="text"
                          placeholder="Enter Last Name"
                          name="lastName"
                          value={RegisterData.lastName}
                          onChange={handleOnChange}
                          className={`login-input w-100 ${validations.lastNameVal && "border-red-500"}`}
                        />
                        {validations.lastNameVal && <p className="text-xs mt-1" style={{ color: 'red' }}>{validations.lastNameVal}</p>}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">Email <span className="text-red-500">*</span></label>
                        <input
                          type="email"
                          placeholder="Enter Email"
                          name="email"
                          value={RegisterData.email}
                          onChange={handleOnChange}
                          onBlur={handleCheckDealerEmail}
                          className={`login-input w-100 ${validations.emailVal && "border-red-500"}`}
                        />
                        {validations.emailVal && <p className="text-xs mt-1" style={{ color: 'red' }}>{validations.emailVal}</p>}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="login-cinematic-input-wrapper mb-3 cinematic-phone-input">
                        <label className="text-slate-400 text-sm mb-1 block">Contact No <span className="text-red-500">*</span></label>
                        <PhoneInput
                          country={phoneCountry}
                          value={RegisterData.contactNo}
                          disableDropdown={true}
                          onChange={handlePhoneChange}
                          inputProps={{ name: "contactNo", required: true }}
                          className={`w-100 ${validations.contactNoVal && "border-red-500"}`}
                          enableAreaCodes={true}
                        />
                        {validations.contactNoVal && <p className="text-xs mt-1" style={{ color: 'red' }}>{validations.contactNoVal}</p>}
                      </div>
                    </div>
                  </div>
                )}

                {currentStep === 2 && (
                  <div className="row animate-in">
                    <div className="col-12 mb-3">
                      <h3 className="text-slate-200 mb-2 border-bottom border-slate-700 pb-2">Login Details</h3>
                    </div>
                    <div className="col-12">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">User Name <span className="text-red-500">*</span></label>
                        <input
                          type="text"
                          placeholder="Enter User Name"
                          name="userName"
                          value={RegisterData.userName}
                          onChange={handleOnChange}
                          onBlur={handleCheckDealerUser}
                          className={`login-input w-100 ${validations.userNameVal && "border-red-500"}`}
                        />
                        {validations.userNameVal && <p className="text-xs mt-1" style={{ color: 'red' }}>{validations.userNameVal}</p>}
                      </div>
                    </div>
                    <div className="col-12 position-relative">
                      <div className="login-cinematic-input-wrapper mb-3">
                        <label className="text-slate-400 text-sm mb-1 block">Password <span className="text-red-500">*</span></label>
                        <div style={{ position: 'relative' }}>
                          <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter Password"
                            name="password"
                            value={RegisterData.password}
                            onChange={handleOnChange}
                            className={`login-input w-100 ${validations.passwordVal && "border-red-500"}`}
                            style={{ paddingRight: '48px' }}
                          />
                          <span 
                            onClick={handlePassShowHide}
                            style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#94a3b8', zIndex: 10, display: 'flex', alignItems: 'center', height: '24px', width: '24px', justifyContent: 'center' }}
                          >
                            <i className={showPassword ? "fa fa-eye" : "fa fa-eye-slash"} style={{ fontSize: '16px' }}></i>
                          </span>
                        </div>
                        {validations.passwordVal && <p className="text-xs mt-1" style={{ color: 'red', maxWidth: '400px' }}>{validations.passwordVal}</p>}
                      </div>
                    </div>
                  </div>
                )}

                <div className="stepper-nav flex gap-3 mt-5">
                  {currentStep > 0 && (
                    <Button onClick={handleBack} className="login-cinematic-btn-secondary w-100">
                      Back
                    </Button>
                  )}
                  {currentStep < 2 ? (
                    <Button type="primary" onClick={handleNext} className="login-cinematic-btn-primary w-100">
                      Next Step
                    </Button>
                  ) : (
                    <Button 
                      type="primary" 
                      onClick={handleRegister} 
                      loading={submitLoading}
                      className="login-cinematic-btn-primary w-100"
                    >
                      Register
                    </Button>
                  )}
                </div>

                <p className="text-center text-slate-400 mt-4">
                  Already have an account? <Link to="/" className="text-blue-400 hover:text-blue-300 font-semibold" style={{ textDecoration: 'none' }}>Login Here</Link>
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <footer className="login-cinematic-footer">
        <div className="login-cinematic-footer-links">
          <img
            src={WhiteLabeling?.whiteLebelData?.[0]?.footerLogo || footerCompanyLogo1}
            alt="Logo"
            style={{ height: "18px", filter: "brightness(0) invert(1)", cursor: "pointer" }}
            onClick={() => handleOpenLink(WhiteLabeling?.whiteLebelData?.[0]?.footerLogoLink || "")}
          />
          <Link to={"/termsOfService"} onClick={handleOnTop}>{t("Terms of Service")}</Link>
          <Link to={"/privacyStatement"} onClick={handleOnTop}>{t("Privacy Statement")}</Link>
        </div>
        <div>
          Copyright {new Date().getFullYear()} {WhiteLabeling?.whiteLebelData?.[0]?.name || "JewelCloud"}
        </div>
      </footer>

      <Modal
        visible={visible}
        onOk={() => navigate("/")}
        onCancel={() => setVisible(false)}
        footer={[
          <Button key="submit" type="primary" onClick={() => navigate("/")} className="login-cinematic-btn-primary">
            Ok
          </Button>,
        ]}
      >
        <div className="text-center p-4">
          <h4 className="text-xl font-bold mb-2">Thank You For Registering</h4>
          <p className="text-slate-600">Please check your mail for an activation link</p>
        </div>
      </Modal>
    </div>
  );
};

export default Register;
